module.exports = __webpack_public_path__ + "static/media/june.4ac91eaa.png";